@let i18nPrefixValue = i18nPrefix();

<cappus-list-filter-panel-wrapper
  *transloco="let t; prefix: i18nPrefixValue"
  [i18nPrefix]="i18nPrefixValue"
  [isExpandedFilterPanel]="isExpandedFilterPanel()"
  [searchTextControl]="form.controls.searchText"
  (isExpandedFilterPanelChange)="isExpandedFilterPanel.set($event)"
>
  <!--  todo: open the singleControlDialog to create new forbidden nickname-->
  <ng-template #buttons>
    <button class="max-md:w-full" mat-flat-button type="button" (click)="clickOnNew.emit()">
      <mat-icon customMatSvgIcon="pct-mdi-plus" />
      {{ t('BUTTONS.GO_TO_NEW') }}
    </button>
  </ng-template>
</cappus-list-filter-panel-wrapper>
